import Vue from 'vue';
import '../scss/styles.scss';
import { ProductGridItem } from '../models/ProductGridItem';

export default Vue.extend({
  name: 'productitem',
  props: {
    items: {
      type: Array as () => ProductGridItem[],
      required: true,
    },
  },
  methods: {
    go() {},
    loadMore() {
      this.itemsShown += 4;
      this.$emit('loadMoreClicked');
    },
    clicked(item: ProductGridItem) {
      this.$emit('productItemClicked', item);
    },
  },
  data() {
    return {
      itemsShown: 4,
    };
  },
});
